import { ExpandMoreRounded } from "@mui/icons-material";
import {
  Accordion as MuiAccordion,
  AccordionDetails,
  AccordionSummary,
  Divider,
} from "@mui/material";
import * as React from "react";
import { Fragment } from "react";

// Rows are keyed by `item.id` when the caller supplies one, falling back to the
// array index. The index alone is wrong whenever the list can reorder: the POS
// cart unshifts new lines to the front, so every existing row's index shifts on
// each add and React hands a row's open/closed state to whichever row slid into
// its slot. Callers that pass no id keep the previous behaviour exactly.
const Accordion = (props) => {
  const { items, ...other } = props;
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  // A removed row must not leave its panel open — otherwise the row that takes
  // its place inherits the expansion.
  const panelIds = items.map((item, i) => `panelId:${item.id ?? i}`);
  const panelIdsKey = panelIds.join("|");
  React.useEffect(() => {
    setExpanded((cur) => (cur && !panelIds.includes(cur) ? false : cur));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [panelIdsKey]);

  return (
    <div>
      {items.map((item, i) => (
        <Fragment key={item.id ?? i}>
          <MuiAccordion
            expanded={expanded === `panelId:${item.id ?? i}`}
            onChange={handleChange(`panelId:${item.id ?? i}`)}
            sx={{
              backgroundColor: "transparent",
              boxShadow: "none",
              m: "0px",
              "&.MuiPaper-root.MuiAccordion-root:before": {
                display: "none",
              },
            }}
            {...other}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreRounded />}
              aria-controls="panel1bh-content"
              id="panel1bh-header"
              sx={{
                flexDirection: "row-reverse",
                px: "8px",
                "&.Mui-focusVisible": { backgroundColor: "transparent" },
                "& .MuiAccordionSummary-content": { m: 0 },
                "& .MuiAccordionSummary-content.Mui-expanded": { m: 0 },
                "& .MuiAccordionSummary-expandIconWrapper .MuiSvgIcon-root": {
                  fontSize: 18,
                  m: "2px",
                },
              }}
            >
              {item.header}
            </AccordionSummary>
            <AccordionDetails sx={{ pt: 0, pb: "2px", px: "8px" }}>{item.body}</AccordionDetails>
          </MuiAccordion>
          <Divider />
        </Fragment>
      ))}
    </div>
  );
};

export default Accordion;
